<div class="formHeader">
  Manage your user preferences below.
</div>

<form class="formFieldList" [formGroup]="form" style="width:100%;">

  <ng-container *ngFor="let category of getPreferenceCategories()">
  <div class="preference-header"><b>{{category.label}}</b></div>
  <div class="preference-row" *ngFor="let pref of getPreferencesByCategory(category.category)">
    <span [matTooltip]="pref.description">{{getPreferenceLabel(pref)}}</span>
    <div>
      <ng-container *ngIf="pref.type == 'boolean'">
        <mat-radio-group aria-label="Select an option" [formControlName]="pref.key + '.value'">
          <mat-radio-button value="true">Yes</mat-radio-button>
          <mat-radio-button value="false">No</mat-radio-button>
        </mat-radio-group>
      </ng-container>
      <mat-checkbox style="padding-left:10px;" [formControlName]="pref.key + '.useDefault'" (change)="updatePreferenceEnabled($event, pref.key)">Use Default</mat-checkbox>
    </div>
  </div>
  </ng-container>

</form>